module.exports = __webpack_public_path__ + "img/circle_num_2.b5ff4f88.svg";